module.exports = __webpack_public_path__ + "montserrat-light-webfont.8cde2a0e8a4a698a32a3.svg";


//////////////////
// WEBPACK FOOTER
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/~/@okta/okta-signin-widget/dist/font/montserrat-light-webfont.svg
// module id = ../../../../@okta/okta-signin-widget/dist/font/montserrat-light-webfont.svg
// module chunks = 11